define('dashboard',['controller', 'socket'], function(controller, socket) {
	
	// ======================== socket events ========================
	
	function onDashboard(e) {
		$('#notifications').prepend(e.html);
	}
	
	controller.on('admin/dashboard/index', function() {
		socket.on('admin-dashboard', onDashboard);
	}, function() {
		socket.off('admin-dashboard', onDashboard);
	});
});

